<template functional>
  <footer class="site-footer">
    <div class="links flex justify-between max-w-1/3 w-full md:w-2/3 xl:w-1/3 ">
      <router-link to="/">Home</router-link> | <router-link to="/about">About</router-link> | <router-link to="/support">Support</router-link> | <a target="_blank" href="https://www.ranker.com/terms?ref=foot">Terms of Service</a> | <a target="_blank" href="https://www.ranker.com/terms?ref=foot&view=privacy">Privacy</a>
    </div>
    <div class="copyright">
      Copyright © Ranker, {{ (new Date).getFullYear() }}. All Rights Reserved.
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
};
</script>

<style lang="postcss">
.site-footer {
  padding: 0 50px 0 50px;
  height: 150px;
  background: #090A14;
  @apply flex flex-col justify-center items-center;

  .links, .links a, .copyright {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    font-feature-settings: 'ss04' on;

    color: #FFFFFF;
  }

  .copyright {
    margin-top: 20px;
  }
}

</style>